import { useState } from "react";

export default function Contact() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [contact, setContact] = useState("");
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!name || !email || !contact) {
      alert("All fields are required");
      return;
    }

    setLoading(true);

    try {
      const res = await fetch("https://archpoint.onrender.com/api/contacts", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ name, email, contact }),
      });

      const data = await res.json();

      if (!data.success) {
        throw new Error(data.message || "Something went wrong");
      }

      setSubmitted(true);
      setName("");
      setEmail("");
      setContact("");

      setTimeout(() => setSubmitted(false), 3000);
    } catch (err) {
      alert(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="w-full max-w-sm mx-auto">
      {submitted && (
        <div className="mb-4 p-3 bg-green-100 text-green-800 rounded-lg text-center font-medium">
          ✓ Message sent successfully!
        </div>
      )}

      <form onSubmit={handleSubmit} className="space-y-4">
        <input
          type="text"
          placeholder="Name"
          value={name}
          onChange={(e) => setName(e.target.value)}
          required
          className="w-full rounded-lg border-2 border-gray-200 px-4 py-2.5 text-sm
            focus:outline-none focus:border-yellow-500 transition"
        />

        <input
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          className="w-full rounded-lg border-2 border-gray-200 px-4 py-2.5 text-sm
            focus:outline-none focus:border-yellow-500 transition"
        />

        <textarea
          placeholder="Message"
          value={contact}
          onChange={(e) => setContact(e.target.value)}
          required
          rows={3}
          className="w-full rounded-lg border-2 border-gray-200 px-4 py-2.5 text-sm
            focus:outline-none focus:border-yellow-500 transition resize-none"
        />

        <button
          type="submit"
          disabled={loading}
          className="w-full rounded-lg bg-yellow-500 py-2.5 text-sm font-semibold text-white
            hover:bg-yellow-600 disabled:opacity-60 transition"
        >
          {loading ? "Sending..." : "Send Message"}
        </button>
      </form>
    </div>
  );
}